import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import ConsoleWrapper from '@/docs-partials/endpoints/console';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h2>{`GIPHY Clips Search Endpoint`}</h2>
    <p>{`Returns list of video content from GIPHY's network content based on given query phase.`}</p>
    <ul>
      <li parentName="ul">{`Access to Clips endpoints is only available upon approval. Please reach out to `}<a parentName="li" {...{
          "href": "clips@giphy.com"
        }}>{`clips@giphy.com`}</a>{` to request permission.`}</li>
      <li parentName="ul">{`Optionally, use the &rating param to tailor the response per your preferences. Read more `}<a parentName="li" {...{
          "href": "https:/developers.giphy.com/branch/master/docs/optional-settings#rating"
        }}>{`here`}</a>{` about content ratings.`}</li>
      <li parentName="ul">{`Optionally, you can use `}<a parentName="li" {...{
          "href": "https:/developers.giphy.com/branch/master/docs/optional-settings#renditions-on-demand"
        }}>{`rendition on demand`}</a>{` bundles to limit which renditions the API sends.`}</li>
    </ul>
    <h3>{`Request`}</h3>
    <ConsoleWrapper mdxType="ConsoleWrapper">
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": "left"
            }}></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}>{`GET /v1/clips/search`}</td>
          </tr>
        </tbody>
      </table>
    </ConsoleWrapper>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Parameter:`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Required:`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description:`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`api_key`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Your issued API key`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`q`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Search phrase; Should be the exact terms the user searched for without any correction/enhancement. `}<br />{` Maximum length: 50 chars.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`limit`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Number of content to return from the offset. Defaults to 25.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`offset`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The offset to start returning content. Defaults to 0.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`country_code`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The country code, in ISO-3166-1 alpha-2 format. Defaults to automatic detection based on IP. Required if API is implemented via a proxy.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`lang`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The language code, in ISO-639-1 format. Defaults to automatic detection based on IP.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`rating`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The maximum rating of content to return. Defaults to R.`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Response`}</h3>
    <h5>{`Success 200`}</h5>
    <ConsoleWrapper mdxType="ConsoleWrapper">
  <ul>
    <li>
      data: <a href="/docs/clips/schema">Clip Object</a>[]
    </li>
    <li>
      pagination: <a href="/docs/api/schema#pagination-object">Pagination Object</a>
    </li>
    <li>
      meta: <a href="/docs/api/schema#meta-object">Meta Object</a>
    </li>
  </ul>
    </ConsoleWrapper>
    <h5>{`Error 4xx/5xx`}</h5>
    <ConsoleWrapper mdxType="ConsoleWrapper">
  <ul>
    <li>data: []</li>
    <li>
      meta: <a href="/docs/api/schema#meta-object">Meta Object</a>
    </li>
  </ul>
    </ConsoleWrapper>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      